import React from 'react';
import { motion } from 'framer-motion';

const spring = { type: 'spring', stiffness: 100, damping: 20 };

export const fadeUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { ...spring, delay } },
});

export const Reveal = ({ children, delay = 0, className = '', as = 'div', ...rest }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: '-80px' }}
      variants={fadeUp(delay)}
      className={className}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const Stagger = ({ children, className = '', stagger = 0.1, ...rest }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: '-80px' }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: stagger } } }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Item = ({ children, className = '', ...rest }) => (
  <motion.div variants={fadeUp()} className={className} {...rest}>
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, dark = false, align = 'center', className = '' }) => (
  <Reveal className={`${align === 'center' ? 'text-center mx-auto' : 'text-left'} max-w-3xl ${className}`}>
    {eyebrow && (
      <span className={`eyebrow ${dark ? 'text-amber-300' : 'text-violet-700'}`}>
        <span className="eyebrow-line" />
        {eyebrow}
      </span>
    )}
    <h2 className={`mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.08] ${dark ? 'text-white' : 'text-slate-900'}`}>
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? 'text-slate-300' : 'text-slate-600'}`}>
        {subtitle}
      </p>
    )}
  </Reveal>
);
